'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseCarousel = require('./components/BaseCarousel.component');

var _BaseCarousel2 = _interopRequireDefault(_BaseCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { BaseCarousel: _BaseCarousel2.default };


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/carousel-base/lib/index.js
// module id = 1404
// module chunks = 1